import React, { FunctionComponent } from "react";

import { Cart } from "../../../../../../context/CartContext/CartContext.api.types";
import { displayMoney } from "../../../../../../utils/displayMoney";
import { displayWeight } from "../../../../../../utils/displayWeight";

import "./SummaryTableComponent.scss";
import classNames from "classnames";
import useDevice from "../../../../../../utils/hooks/useDevice";

type Props = {
  cart: Cart;
};

const ReportTotal: FunctionComponent<{
  children: React.ReactNode;
  modifier: "gold" | "silver";
}> = ({ children, modifier }) => (
  <div className="report-total summary-table__value__text summary-table__value__text--total">
    <div className={`report-total__icon report-total__icon--${modifier}`} />
    <span style={{ fontFamily: "Mont-Bold" }}>{children}</span>
  </div>
);

const SummaryTableTextHeader: FunctionComponent<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <span
    className={classNames(
      "summary-table__text summary-table__text--header",
      className
    )}
  >
    {children}
  </span>
);

const SummaryTableText: FunctionComponent<{
  children: React.ReactNode;
}> = ({ children }) => <span className="summary-table__text">{children}</span>;

const SummaryTableTextTotal: FunctionComponent<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <span
    className={classNames(
      "summary-table__text summary-table__text--total",
      className
    )}
  >
    {children}
  </span>
);

const SummaryTableComponent: FunctionComponent<Props> = ({ cart }) => {
  const { isMobile } = useDevice();
  return (
    <table className="summary-table">
      <thead>
        <tr>
          <th>
            <SummaryTableTextHeader>&nbsp;</SummaryTableTextHeader>
          </th>
          <th>
            <SummaryTableTextHeader>Gramos</SummaryTableTextHeader>
          </th>
          <th>
            <SummaryTableTextHeader>&nbsp;</SummaryTableTextHeader>
          </th>
          <th>
            <SummaryTableTextHeader>Hechura</SummaryTableTextHeader>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <SummaryTableTextHeader className="summary-table__text summary-table__text--left">
              Oro:
            </SummaryTableTextHeader>
          </td>
          <td>
            <SummaryTableText>
              {displayWeight(cart.summary.by_material.gold.weight)}
            </SummaryTableText>
          </td>

          <td>
            <SummaryTableText>&nbsp;</SummaryTableText>
          </td>

          <td>
            <SummaryTableText>
              {displayMoney(cart.summary.by_material.gold.manufacturingCost)}
            </SummaryTableText>
          </td>
        </tr>
        <tr>
          <td>
            <SummaryTableTextHeader className="summary-table__text summary-table__text--left">
              Plata:
            </SummaryTableTextHeader>
          </td>

          <td>
            <SummaryTableText>&nbsp;</SummaryTableText>
          </td>
          <td>
            <SummaryTableText>
              {displayWeight(cart.summary.by_material.silver.weight)}
            </SummaryTableText>
          </td>
          <td>
            <SummaryTableText>
              {displayMoney(cart.summary.by_material.silver.manufacturingCost)}
            </SummaryTableText>
          </td>
        </tr>
        <tr>
          <td>
            <SummaryTableTextTotal className="summary-table__text--total--semibold summary-table__text--left">
              Total:
            </SummaryTableTextTotal>
          </td>
          <td>
            <SummaryTableTextTotal>
              <ReportTotal modifier="gold">
                {cart.summary.by_material.gold.weight > 999 && isMobile
                  ? `${Number(
                      cart.summary.by_material.gold.weight / 1000
                    ).toFixed(2)} kg`
                  : displayWeight(cart.summary.by_material.gold.weight)}
              </ReportTotal>
            </SummaryTableTextTotal>
          </td>
          <td>
            <SummaryTableTextTotal>
              <ReportTotal modifier="silver">
                {cart.summary.by_material.silver.weight > 999 && isMobile
                  ? `${Number(
                      cart.summary.by_material.silver.weight / 1000
                    ).toFixed(2)} kg`
                  : displayWeight(cart.summary.by_material.silver.weight)}
              </ReportTotal>
            </SummaryTableTextTotal>
          </td>
          <td>
            <SummaryTableTextTotal>
              {displayMoney(cart.summary.totals.manufacturingCost)}
            </SummaryTableTextTotal>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default SummaryTableComponent;
